import React from "react";
import PropTypes from "prop-types";
import {
  readyData,
  calculateMuscleGroupsColors,
} from "../../../../utils/workout-stats";
import MuscleBodyLight from "./MuscleBodyLight";

const selectExerciseList = (locals) =>
  locals.currentYearExercises || locals.activeExercises || [];
const selectCurrentDateExercises = (locals) => locals.activeExercises || [];

const MuscleDiagramCard = (props, { locals }) => {
  const { isComposition } = props;
  // muscle diagram data
  const muscleGroupsIntensity = readyData({
    exerciseList: selectExerciseList(locals),
    date: locals.query.date,
    activeExercises: selectCurrentDateExercises(locals),
    isComposition,
  });
  const muscleGroupsColors = calculateMuscleGroupsColors(muscleGroupsIntensity);

  const config = {
    backcolor: muscleGroupsColors.Back,
    glutescolor: muscleGroupsColors.Glutes,
    calvescolor: muscleGroupsColors.Calves,
    legscolor: muscleGroupsColors.Legs,
    forearmscolor: muscleGroupsColors.Forearms,
    tricepscolor: muscleGroupsColors.Triceps,
    bicepscolor: muscleGroupsColors.Biceps,
    abscolor: muscleGroupsColors.Abs,
    chestcolor: muscleGroupsColors.Chest,
    shoulderscolor: muscleGroupsColors.Shoulders,
  };
  const chooseWrapper = (isComposition) =>
    isComposition ? "composition-content-wrapper" : "content-wrapper";
  const changeLegendOrder = (isComposition) =>
    isComposition && {
      display: "flex",
      maxWidth: "245px",
      justifyContent: "space-between",
      margin: "auto",
    };
  const renderTitle = (isComposition) =>
    !isComposition && <p className="s1 mb-4">Workload by Muscle Group</p>;
  const targetStyle = { width: "100%", aspectRatio: 100 / 92.669 };
  return (
    <div className="card muscle-diagram">
      {renderTitle(isComposition)}
      <div className={chooseWrapper(isComposition)}>
        <div style={targetStyle}>
          <MuscleBodyLight {...config} />
        </div>
        <div
          className="intensity-legend"
          style={changeLegendOrder(isComposition)}
        >
          <div className="max">Max</div>
          <div className="heavy">Heavy</div>
          <div className="medium">Medium</div>
        </div>
      </div>
    </div>
  );
};

MuscleDiagramCard.contextTypes = { locals: PropTypes.object };

export default MuscleDiagramCard;
